import { render, staticRenderFns } from "./messageBanner.vue?vue&type=template&id=9a36d666&scoped=true"
import script from "./messageBanner.vue?vue&type=script&lang=js"
export * from "./messageBanner.vue?vue&type=script&lang=js"
import style0 from "./messageBanner.vue?vue&type=style&index=0&id=9a36d666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a36d666",
  null
  
)

export default component.exports